// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Omni Environments API
 * API to manage Omni Development Environments
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RequestEnvironmentMetadata } from './RequestEnvironmentMetadata';
import {
  RequestEnvironmentMetadataFromJSON,
  RequestEnvironmentMetadataFromJSONTyped,
  RequestEnvironmentMetadataToJSON,
  RequestEnvironmentMetadataToJSONTyped,
} from './RequestEnvironmentMetadata';
import type { RequestEnvironmentSpec } from './RequestEnvironmentSpec';
import {
  RequestEnvironmentSpecFromJSON,
  RequestEnvironmentSpecFromJSONTyped,
  RequestEnvironmentSpecToJSON,
  RequestEnvironmentSpecToJSONTyped,
} from './RequestEnvironmentSpec';

/**
 *
 * @export
 * @interface RequestEnvironment
 */
export interface RequestEnvironment {
  /**
   *
   * @type {RequestEnvironmentMetadata}
   * @memberof RequestEnvironment
   */
  metadata?: RequestEnvironmentMetadata;
  /**
   *
   * @type {RequestEnvironmentSpec}
   * @memberof RequestEnvironment
   */
  spec?: RequestEnvironmentSpec;
}

/**
 * Check if a given object implements the RequestEnvironment interface.
 */
export function instanceOfRequestEnvironment(
  value: object,
): value is RequestEnvironment {
  return true;
}

export function RequestEnvironmentFromJSON(json: any): RequestEnvironment {
  return RequestEnvironmentFromJSONTyped(json, false);
}

export function RequestEnvironmentFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): RequestEnvironment {
  if (json == null) {
    return json;
  }
  return {
    metadata:
      json['metadata'] == null
        ? undefined
        : RequestEnvironmentMetadataFromJSON(json['metadata']),
    spec:
      json['spec'] == null
        ? undefined
        : RequestEnvironmentSpecFromJSON(json['spec']),
  };
}

export function RequestEnvironmentToJSON(json: any): RequestEnvironment {
  return RequestEnvironmentToJSONTyped(json, false);
}

export function RequestEnvironmentToJSONTyped(
  value?: RequestEnvironment | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    metadata: RequestEnvironmentMetadataToJSON(value['metadata']),
    spec: RequestEnvironmentSpecToJSON(value['spec']),
  };
}
